import { useContext } from "react";
import invariant from "ts-invariant";

import { RouteContext } from "@/contexts/RouteContext";

export function useRoute() {
  const route = useContext(RouteContext);
  invariant(route, "useRoute must be used within an RouteProvider");
  return route;
}
